<template>
  <ul class="product-advantages">
    <li
      v-for="(advantage, index) in advantages"
      :key="index"
      :class="{ 'product-advantage--green': orderToHighlight === index + 1 }"
      class="product-advantage">
      {{ advantage }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ProductAdvantages',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    advantages() {
      return this.product.advantages?.filter((a) => !!a) || [];
    },

    orderToHighlight() {
      return this.product.meta?.advantageOrderToHighlight;
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-advantages {
    //--background-color: transparent;

    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;

    &:before {
      content: '';
      position: absolute;
      background: var(--background-color, transparent);
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }

  .product-advantage {
    position: relative;
    padding: 0 .85em;
    font-size: 1em;
    z-index: 3;
    margin: .35em 0;

    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 6px;
      height: 1px;
      background-color: $color--basic-green;
    }

    &:before {
      transform: translateY(-2.5px) rotate(45deg);
    }

    &:after {
      transform: translateY(0.5px) rotate(-45deg);
    }
  }

  .product-advantage--green {
    color: $color--basic-green;
  }
</style>
